<template>
  <keep-alive include="groups-list">
    <router-view :key="$route.fullPath"></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "group-wrapper"
  };
</script>

<style>
</style>
